import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main';
import {} from './const';

export const Schedule = () => {
  return (
    <>
      <DocumentHead title={'Schedule'} />
      <PageTemplate main={<Main />} />
    </>
  );
};
